import RequestQuoteIcon from "@mui/icons-material/RequestQuote";
import FeeStructuresGridPage from "./FeeStructuresGridPage";

export default {
  list: FeeStructuresGridPage,
  icon: RequestQuoteIcon,
  label: "Fee structures",
  options: { label: "Fee structures" },
  name: "feeStructures",
};
